function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import * as React from 'react';

import DatalistItem from '../datalist-item';

import './ContactDatalistItem.scss';

var ContactDatalistItem = function ContactDatalistItem(_ref) {
    var name = _ref.name,
        subtitle = _ref.subtitle,
        rest = _objectWithoutProperties(_ref, ['name', 'subtitle']);

    return React.createElement(
        DatalistItem,
        rest,
        React.createElement(
            'div',
            { className: 'contact-text contact-name' },
            name
        ),
        subtitle && React.createElement(
            'div',
            { className: 'contact-text contact-sub-name' },
            subtitle
        )
    );
};

ContactDatalistItem.propTypes = {
    name: PropTypes.node.isRequired,
    subtitle: PropTypes.node
};
export default ContactDatalistItem;
import PropTypes from 'prop-types';